import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_TOTAL_REPORTS = restRequest("SUBMITTED_REPORTS.GET_TOTAL_REPORTS");
export const SET_DATE_FROM = "SUBMITTED_REPORTS.SET_DATE_FROM";
export const SET_DATE_TO = "SUBMITTED_REPORTS.SET_DATE_TO";
export const GET_USERNAMES = restRequest("SUBMITTED_REPORTS.GET_USERNAMES");
export const SET_UID = "SUBMITTED_REPORTS.SET_UID";
export const SET_WORKSHEET_STATUS = restRequest("SUBMITTED_REPORTS.SET_WORKSHEET_STATUS");

export const FILTER_WORKSHEET_STATUS = "SUBMITTED_REPORTS.FILTER_WORKSHEET_STATUS";
export const GET_REPORT_TITLES = restRequest("SUBMITTED_REPORTS.GET_REPORT_TITLES");
export const SET_REPORT_TYPE = "SUBMITTED_REPORTS.SET_REPORT_TYPE";
export const GET_JOBPACKS = restRequest("SUBMITTED_REPORTS.GET_JOBPACKS");
export const SET_JOB_ID = "SUBMITTED_REPORTS.SET_JOB_ID";
export const SET_SELECTED_ROW = "SUBMITTED_REPORTS.SET_SELECTED_ROW";
